import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { selector as createDasApi } from './createDas/createDasSlice';
import { Status } from "../../../common/constants";
import { useSpinner } from "../../../customHooks";
import { selector as listAlertTypesApi } from './createDas/listAlertTypesSlice'
import { listAlertTypes } from "./createDas/listAlertTypesSlice";
import { fetchDasSubscriptionsData } from "./listDas/listDasSlice";
import { actions as spinnerActions } from '../../../components/ui/spinner/spinnerSlice';

export const useCreateDasAlertNotification = () => {
    const dispatch: any = useDispatch();
    const createDasAlertResponse = useSelector(createDasApi);
    const alertTypesResponse = useSelector(listAlertTypesApi);

    useSpinner();

    useEffect(() => {
        dispatch(spinnerActions.setApiStatus(alertTypesResponse.status));
    }, [alertTypesResponse.status])


    useEffect(() => {
        if (alertTypesResponse.status !== Status.SUCCESS) {
            dispatch(listAlertTypes());
        }
    }, [dispatch])

    useEffect(() => {
        if (createDasAlertResponse.status === Status.SUCCESS) {
            dispatch(fetchDasSubscriptionsData());
        }
    }, [createDasAlertResponse]);

}